/**
 * useOcrImage Hook
 *
 * Custom hook to extract image logic from OcrSection component
 * Reduces component complexity and improves maintainability.
 */

import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { useMemo } from 'react';

export function useOcrImage(selectedItem: GraphQLAuditItem | null) {
  // Image logic - similar to AuditItemContent
  const { imageUrl, shouldShowImage, isSafeContent } = useMemo(() => {
    const contentUrl = selectedItem?.contentSnapshot?.contentUrl;
    const contentType = selectedItem?.contentSnapshot?.contentType?.toLowerCase();
    const classificationType = selectedItem?.contentSnapshot?.classificationType;

    return {
      imageUrl: contentUrl,
      shouldShowImage: contentUrl && contentType === 'image',
      isSafeContent: classificationType === 'safe_content',
    };
  }, [selectedItem?.contentSnapshot?.contentUrl, selectedItem?.contentSnapshot?.contentType, selectedItem?.contentSnapshot?.classificationType]);

  return {
    imageUrl,
    shouldShowImage,
    isSafeContent,
  };
}
